<div class="filter-input-element">
  <nz-date-picker
    *ngIf="![6, 7].includes(operator.operator)"
    class="date-input-full"
    [(ngModel)]="value"
    (ngModelChange)="onChange($event)"
    
    
  ></nz-date-picker>

  <div class="double-input-filter" *ngIf="[6, 7].includes(operator.operator)">
    <nz-date-picker
      class="date-input-full"
      [(ngModel)]="firstValue"
      (ngModelChange)="onChange($event)"
      [nzPlaceHolder]="'From'  | translate"
    ></nz-date-picker>
    <nz-date-picker
      class="date-input-full"
      [(ngModel)]="secondValue"
      (ngModelChange)="onChange($event)"
      [nzPlaceHolder]="'To'  | translate"
    ></nz-date-picker>

    <p style="color: red" *ngIf="hasError">{{ errorMessage }}</p>
  </div>
</div>
